export default __webpack_public_path__ + "static/media/our-history.91728631.png";